'use client';

import { usePageLoader } from '@/hooks/usePageLoader';
import PageLoader from '@/components/common/PageLoader';

interface PageLoaderWrapperProps {
  children: React.ReactNode;
}

export default function PageLoaderWrapper({ children }: PageLoaderWrapperProps) {
  const isLoading = usePageLoader();

  return (
    <>
      <PageLoader isLoading={isLoading} />
      {children}
    </>
  );
}